export default __webpack_public_path__ + "static/media/moltensteelslash1.8cd72422.png";